import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { Row, Col, Button, Form, FormGroup, Label, Input, FormFeedback, FormText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { redirect, setRedirect } from '../../../App/AppActions';
import { displayErrors } from '../../../Error/ErrorActions';

import { activateAccountRequest, checkPassword } from '../../AuthActions';

class UserNewPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: props.user,
            isSaving: false,
            errorFields: [],
        };
    }

    handleChange = event => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState({
            [name]: value,
        });
    };

    hasErrorField = name => {
        return this.state.errorFields && this.state.errorFields.indexOf(name) !== -1;
    };

    handleSubmit = event => {
        event.preventDefault();

        const errorFields = [];

        if(!this.state.password) {
            errorFields.push('password');
        } else if(!this.state.confirmPassword) {
            errorFields.push('confirmPassword');
        } else if(!checkPassword(this.state.password)) {
            errorFields.push('password');
            displayErrors('error', this.props.intl.formatMessage({
                id: 'userPasswordRestriction',
                defaultMessage: 'The password must have 12 characters and at least must have a number, a capital letter and a special character (@&!()$*€%)!',
            }));
            // displayErrors('error', this.props.intl.formatMessage({
            //     id: 'userPasswordRestrictionAlt',
            //     defaultMessage: 'The password must have 6 characters!',
            // }));
        } else if(this.state.password !== this.state.confirmPassword) {
            errorFields.push('confirmPassword');
            displayErrors('error', this.props.intl.formatMessage({
                id: 'userPasswordConfirmationError',
                defaultMessage: 'The password and the confirmation must be the same!',
            }));
        }

        if(!errorFields.length) {
            this.setState({
                isSaving: true,
            });
            this.props.dispatch(activateAccountRequest(this.props.identifier, this.state.password, this.props.activationCode)).then(result => {
                console.log('Activation result', result);
                this.setState({
                    isSaving: false,
                });
                if(!result) {
                    displayErrors('error', this.props.intl.formatMessage({
                        id: 'userResetPasswordError',
                        defaultMessage: 'Unable to reset your password! Please retry...',
                    }));
                } else if(!this.state.newPasswordRequired) {
                    if(this.props.closeForm) {
                        this.props.closeForm(result, this.state.password);
                    } else {
                        this.props.redirect !== false && this.props.dispatch(setRedirect(this.props.appRedirect || this.props.redirect || '/'));
                    }
                }
            });
        } else {
            this.setState({
                errorFields,
            });
        }
    };

    render() {
        return (
            <div>
                <Form onSubmit={this.handleSubmit}>
                    <p>
                        <strong><FontAwesomeIcon icon="unlock-alt" /> <FormattedMessage id="userPasswordResetText" defaultMessage="Please set your personnal password. Confirm it and click on the button below." /></strong>
                    </p>
                    <FormGroup className="mt-2">
                        <Row>
                            <Col sm="12" xl="6" className={this.hasErrorField('password') ? 'has-danger' : ''}>
                                <Label for="passwordField"><FormattedMessage id="userPassword" defaultMessage="Password" /></Label>
                                <Input type="password" name="password" id="passwordField" className={this.hasErrorField('password') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} value={this.state.password} />
                                {this.hasErrorField('confirmPassword') && <FormFeedback><FormattedMessage id="userPasswordError" defaultMessage="Please fill a correct password!" /></FormFeedback>}
                            </Col>
                            <Col sm="12" xl="6" className={classNames(this.hasErrorField('confirmPassword') && 'has-danger', 'mt-2', 'mt-xl-0')}>
                                <Label for="confirmPasswordField"><FormattedMessage id="userPasswordConfirmation" defaultMessage="Password confirmation" /></Label>
                                <Input type="password" name="confirmPassword" id="confirmPasswordField" className={this.hasErrorField('confirmPassword') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} value={this.state.confirmPassword} />
                                {this.hasErrorField('confirmPassword') && <FormFeedback><FormattedMessage id="userPasswordConfirmationError" defaultMessage="This confirmation must be the same of your password" /></FormFeedback>}
                            </Col>
                        </Row>
                        <FormText color="secondary" className="text-center">
                            <FontAwesomeIcon icon="exclamation-triangle" /> <FormattedMessage id="userPasswordRestriction" defaultMessage="The password must have 12 characters and at least must have a number, a capital letter and a special character (@&!()$*€%)!" />
                        </FormText>
                    </FormGroup>
                    <FormGroup className="mt-5">
                        <Button color="success" block disabled={!this.state.password || !this.state.confirmPassword || this.state.isSaving}>{this.state.isSaving ? <FontAwesomeIcon icon="spinner" spin /> : <FontAwesomeIcon icon="lock" />} <FormattedMessage id="userPasswordCreate" defaultMessage="Set my password" /></Button>
                        {this.props.closeForm && <Button color="link" block onClick={this.props.closeForm}><FontAwesomeIcon icon="chevron-left" /> <FormattedMessage id="back" defaultMessage="Back" /></Button>}
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        intl: store.intl,
        appRedirect: store.app.redirect,
    };
}

UserNewPassword.defaultProps = {
    activationCode: '',
    appRedirect: '',
    redirect: '',
    closeForm: null,
};
UserNewPassword.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    identifier: PropTypes.string.isRequired,
    activationCode: PropTypes.string,
    appRedirect: PropTypes.string,
    redirect: PropTypes.string,
    closeForm: PropTypes.func,
};

export default connect(mapStateToProps)(withIntl(UserNewPassword));
